import styled from '@emotion/styled'

import { LockLockedFillIcon } from '@arcade/web/icons/react'
import { spacing, Text } from '@cash-design-system/react'
import {
  FormBlockerElementNoticeElement,
  FormBlockerElementNoticeElementIcon,
} from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import logger from '@cash-web/shared/util-logger'

const NoticeElementContainer = styled.div`
  border-radius: 1.5rem;
  padding: ${({ theme }) => theme.spacing.l};
  background: ${props => props.theme.colors.secondaryBackground};
  display: grid;
  grid-template-columns: 1.5rem 1fr;
  column-gap: ${spacing.xs};
`

const TextWrapper = styled.div`
  grid-column-start: 2;
  min-height: 1.5rem;
  display: flex;
  align-items: center;
`

const getNoticeIcon = ({ icon }: { icon?: FormBlockerElementNoticeElementIcon }) => {
  if (!icon) {
    return
  }

  switch (icon) {
    case FormBlockerElementNoticeElementIcon.PADLOCK:
      return <LockLockedFillIcon size={24} />
    default:
      logger.error(new Error(`Unsupported notice element icon: ${icon}`))
      return
  }
}

export const NoticeElement = ({ text, icon }: FormBlockerElementNoticeElement) => {
  const noticeIcon = getNoticeIcon({ icon })

  return (
    <NoticeElementContainer>
      {noticeIcon}
      {text && (
        <TextWrapper>
          <Text typography="labelMedium">{text}</Text>
        </TextWrapper>
      )}
    </NoticeElementContainer>
  )
}
